<div class="recaptcha-wrapper">
    <re-captcha (resolved)="resolved($event)" (error)="errored()" errorMode="handled" siteKey="{{adamLabels.recaptchaSiteKey}}" ></re-captcha>
</div>